export const topsColors = [
  "var(--dashboard-top-blue)",
  "var(--dashboard-top-pink)",
  "var(--dashboard-top-green)",
  "var(--dashboard-top-red)",
  "var(--dashboard-top-yellow)",
];
